import React from "react";
import { AppTextField, AppSelectField, AppNumberField } from "../../../../../Components/FormKit";
import { Tooltip } from 'primereact/tooltip';
import "../../../../../Components/FormKit/FormKit.css";
import "../../../../../Components/TableKit/TableKit.css";

// Shared card header style matching tk-table-card spec
const cardHeader = (title) => (
    <div style={{
        background: '#f8fafc',
        padding: '0.65rem 1rem',
        borderBottom: '1px solid #e2e8f0',
        borderRadius: '14px 14px 0 0',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    }}>
        <span style={{ fontWeight: 700, fontSize: '0.72rem', color: '#1565C0', textTransform: 'uppercase', letterSpacing: '0.06em', whiteSpace: 'nowrap' }}>
            {title}
        </span>
        <div style={{ flex: 1, height: '1px', background: '#bfdbfe' }} />
    </div>
);

export const DataForType = ({
    visitsCount, setVisitsCount,
    // tentativeDate and setTentativeDate removed — MANUS coordina la fecha
    // tentativeDate, setTentativeDate,
    fullName, setFullName,
    recipientName, setRecipientName,
    phoneNumber, setPhoneNumber,
    address, setAddress,
    postalCode, setPostalCode,
    municipality, setMunicipality,
    colonia, setColonia,
    isReadOnly, coloniasOptions,
    errors = {},
    showVisitsCount = true,  // false en PF (se renderiza arriba en el card de Estado)
}) => {
    return (
        <div className="fk-root flex flex-column gap-3">

            {/* Card 1: Contacto */}
            <div className="tk-table-card">
                {cardHeader('Información de Contacto')}
                <div style={{ padding: '1rem' }}>
                    <div className="grid">
                        <div className={showVisitsCount ? 'col-12 md:col-3' : 'col-12 md:col-4'}>
                            <AppTextField
                                label="Nombre de la persona"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                placeholder="Nombre / contacto"
                                disabled={isReadOnly}
                                invalid={!!errors.fullName}
                                errorMessage="Campo requerido"
                            />
                        </div>
                        <div className={showVisitsCount ? 'col-12 md:col-3' : 'col-12 md:col-4'}>
                            <AppTextField
                                label="Quién recibe"
                                value={recipientName}
                                onChange={(e) => setRecipientName(e.target.value)}
                                placeholder="Nombre de quien recibe"
                                disabled={isReadOnly}
                                invalid={!!errors.recipientName}
                                errorMessage="Campo requerido"
                                addonRight={!isReadOnly && fullName ? (
                                    <>
                                        <Tooltip target=".btn-copy-name" content="Mismo que el nombre de la persona" position="top" />
                                        <button
                                            type="button"
                                            className="fk-icon-btn btn-copy-name"
                                            onClick={() => setRecipientName(fullName)}
                                            style={{ padding: '0.2rem' }}
                                        >
                                            <i className="pi pi-copy" style={{ fontSize: '0.8rem' }} />
                                        </button>
                                    </>
                                ) : undefined}
                            />
                        </div>
                        <div className={showVisitsCount ? 'col-12 md:col-3' : 'col-12 md:col-4'}>
                            <AppTextField
                                label="Teléfono"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                placeholder="Ej. 5512345678"
                                disabled={isReadOnly}
                                invalid={!!errors.phoneNumber}
                                errorMessage="Campo requerido"
                                keyfilter="pnum"
                                type="tel"
                            />
                        </div>
                        {showVisitsCount && (
                            <div className="col-12 md:col-3">
                                <AppNumberField
                                    label="No. de Visitas"
                                    value={visitsCount}
                                    onValueChange={(e) => setVisitsCount(e.value)}
                                    min={1}
                                    disabled={isReadOnly}
                                    showButtons
                                    buttonLayout="horizontal"
                                    step={1}
                                    incrementButtonClassName="p-button-text p-button-success"
                                    decrementButtonClassName="p-button-text p-button-danger"
                                    incrementButtonIcon="pi pi-plus"
                                    decrementButtonIcon="pi pi-minus"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Date/Time fields commented out — coordinated by MANUS, kept for future re-enable */}

            {/* Card 2: Dirección */}
            <div className="tk-table-card">
                {cardHeader('Dirección del Inmueble')}
                <div style={{ padding: '1rem' }} className="flex flex-column gap-3">
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <AppTextField
                                label="Código Postal"
                                value={postalCode}
                                onChange={(e) => setPostalCode(e.target.value.replace(/\D/g, '').slice(0, 5))}
                                placeholder="CP (5 dígitos)"
                                disabled={isReadOnly}
                                invalid={!!errors.postalCode}
                                errorMessage="Campo requerido"
                                keyfilter="pnum"
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <AppTextField
                                label="Delegación / Municipio"
                                value={municipality}
                                onChange={(e) => setMunicipality(e.target.value)}
                                disabled={isReadOnly}
                                invalid={!!errors.municipality}
                                errorMessage="Campo requerido"
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <AppTextField
                                label="Calle y Número"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Av. Principal 123"
                                disabled={isReadOnly}
                                invalid={!!errors.address}
                                errorMessage="Campo requerido"
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <AppSelectField
                                label="Colonia"
                                value={colonia}
                                options={coloniasOptions}
                                onChange={(e) => setColonia(e.value)}
                                placeholder="Selecciona una colonia"
                                disabled={isReadOnly}
                                filter
                                invalid={!!errors.colonia}
                                errorMessage="Campo requerido"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
